import React, { useEffect, useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: 16,
    marginBottom: 16,
  },

  // Accordion shell
  accordionRoot: {
    '&::before': { display: 'none' },
    borderRadius: '4px 4px 0 0 !important',
    border: '1px solid rgba(245, 245, 245, 1) !important',
    boxShadow: 'none',
    '&.Mui-expanded': { margin: 0 },
  },

  expandedSummary: {
    backgroundColor: 'rgba(245, 245, 245, 1)',
    '&::before': { backgroundColor: 'none' },
    '&.MuiAccordionSummary-root': { maxHeight: 55, minHeight: 55 },
    '&.Mui-expanded': { maxHeight: 55, minHeight: 55 },
    '& .MuiAccordionSummary-expandIcon': { marginRight: '30px !important' },
    '& .MuiAccordionSummary-expandIcon.Mui-expanded': {
      marginRight: '30px !important',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
  },

  accordionDetails: {
    flexDirection: 'column',
  },

  // Header text and icon
  summaryText: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
  },
  summaryIconImg: {
    display: 'block',
  },

  // Comment list
  listOuter: {},
  commentItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    marginTop: 10,
  },
  topRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
  },
  avatarWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 24,
    minHeight: 24,
  },
  avatarIcon: {
    color: 'rgba(48, 164, 97, 1)',
    height: 24,
    width: 24,
  },
  nameTimeRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    gap: 4,
  },
  nameText: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1,
  },
  timeText: {
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(117, 117, 117, 1)',
    lineHeight: 1,
  },

  bottomRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
  },
  indentSpacer: {
    width: 24,
    [theme.breakpoints.down('xs')]: {
      width: 16,
    },
  },
  commentBody: {
    flexGrow: 1,
    fontSize: 12,
    fontWeight: 400,
    color: 'rgba(33, 33, 33, 1)',
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },

  emptyText: {
    fontWeight: 400,
    fontSize: 12,
    color: 'rgba(120, 121, 142, 1)',
    textAlign: 'center',
  },

  // Add comment area
  addWrapOuter: {
    width: '100%',
    marginTop: 10,
  },
  addWrapRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 10,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      gap: 8,
    },
  },
  addAvatar: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  addRight: {
    width: '100%',
    paddingRight: 10,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  textarea: {
    width: '100%',
    height: 80,
    fontSize: 12,
    resize: 'none',
    outline: 'none',
    borderRadius: 4,
    border: '1px solid rgba(224, 224, 224, 1)',
    background: 'rgba(250, 250, 250, 1)',
    padding: '5px 8px 6px 8px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },
  addBtn: {
    position: 'absolute',
    top: 60,
    right: '1%',
    height: 20,
    padding: '4px 5px',
    color: 'rgba(255, 255, 255, 1)',
    borderRadius: 4,
    backgroundColor: 'rgba(2, 136, 209, 1)',
    lineHeight: 1,
    minWidth: 0,
    [theme.breakpoints.down('xs')]: {
      position: 'static',
      marginTop: 8,
      height: 28,
      padding: '6px 10px',
    },
  },
}));

const TaskCommentViewer = (props) => {
  const { block, loader, modalFormState, show, selectedId } = props;
  const classes = useStyles();
  const [comment, setComment] = useState('');

  const filteredComments = Array.isArray(modalFormState?.workflowComments)
    ? modalFormState.workflowComments.filter(
        (c) => c?.action === modalFormState?.workflow?.label
      )
    : [];

  const commentCount = filteredComments.length;

  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    const now = new Date();
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const diffMs = now - date;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffWeeks = Math.floor(diffDays / 7);

    if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    return `${diffWeeks}w`;
  };

  const handleAddComment = () => {
    if (!comment.trim()) return;
    const payload = {
      appId: props.match.params.appid,
      orgId: props.appConfig?.org?._id,
      dataUniqueId: props.data.chartUniqueId + '_Add_Comment_Task_Obligation',
      data: {
        dmId: block.dataModel,
        docId: selectedId,
        comment: comment,
      },
    };
    props.addComment(payload);
  };

  useEffect(() => {
    if (props.formData?.document[props.data.chartUniqueId + '_Add_Comment_Task_Obligation']) {
      setComment('');
      props.clearReduxDataOfCurrentComponent({
        key: 'document',
        subKey: [`${props.data.chartUniqueId}_Add_Comment_Task_Obligation`],
      });
      props.getDataById(selectedId);
    }
  }, [props.formData?.document[props.data.chartUniqueId + '_Add_Comment_Task_Obligation']]); // eslint-disable-line

  return (
    <div className={classes.wrapper}>
      {props.formData?.[`${props.data.chartUniqueId}_Add_Comment_Task_Obligation_loading`]
        ? loader
        : (
          <Accordion className={classes.accordionRoot}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: 'rgba(33, 33, 33, 1)', height: 20, width: 20 }} />}
              aria-controls="panel1a-content"
              className={classes.expandedSummary}
              defaultExpanded={false}
              id="panel1a-header"
            >
              <Typography className={classes.summaryText}>
                <img
                  src="/media/svg/replyComment.svg"
                  alt="replyComment"
                  className={classes.summaryIconImg}
                />
                {`Comment${commentCount > 0 ? ` (${commentCount})` : ''}`}
              </Typography>
            </AccordionSummary>

            <AccordionDetails className={classes.accordionDetails}>
              <div className={classes.listOuter}>
                {modalFormState?.workflow && (() => {
                  const comments = (modalFormState?.workflowComments || [])
                    .filter((c) => c?.action === modalFormState?.workflow?.label);

                  return comments.length > 0 ? (
                    comments.map((c, idx) => (
                      <div key={idx} className={classes.commentItem}>
                        <div className={classes.topRow}>
                          <div className={classes.avatarWrap}>
                            <AccountCircleIcon className={classes.avatarIcon} />
                          </div>
                          <div className={classes.nameTimeRow}>
                            <Typography className={classes.nameText}>{c?.by?.name}</Typography>
                            <Typography className={classes.timeText}>{getTimeAgo(c?.datetime)}</Typography>
                          </div>
                        </div>

                        <div className={classes.bottomRow}>
                          <div className={classes.indentSpacer} />
                          <div style={{ flexGrow: 1 }}>
                            <Typography className={classes.commentBody}>{c?.comment}</Typography>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <Typography className={classes.emptyText}>No comments to show</Typography>
                  );
                })()}
              </div>

              {modalFormState?.workflow && show && (
                <div className={classes.addWrapOuter}>
                  <div className={classes.addWrapRow}>
                    <div className={classes.addAvatar}>
                      <AccountCircleIcon className={classes.avatarIcon} />
                    </div>

                    <div className={classes.addRight}>
                      <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Comment text here"
                        className={classes.textarea}
                      />
                      <Button
                        variant="contained"
                        className={classes.addBtn}
                        onClick={handleAddComment}
                      >
                        Add Comment
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </AccordionDetails>
          </Accordion>
        )}
    </div>
  );
};

export default TaskCommentViewer;
